/* eslint-disable no-unreachable */
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const isEmail = function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
const submitForm = async (e) => {
  e.preventDefault();
  const to = (e.target.to.value);
  const from = (e.target.from.value) + ("@ImHarshit.tech");
  const subject = (e.target.sub.value);
  const text = (e.target.body.value);
  const html = (e.target.html.value);
  const name = (e.target.name.value);
  
  const data = {
    from,
    to,
    name,
    subject,
    text,
    html,
  }
  if (isEmail(to) && isEmail(from)) {
    try {
      // const url = process.env.REACT_APP_EMAIL_URL + "emailservice";
      const url = "https://imharshit.herokuapp.com/emailservice";
      await fetch(url, {  
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
      })
      toast.success("Mail Sent Successfully");
    } catch (error) {
     toast.error(error)
    }
  }
  else {
    toast.error("Enter valid Sender address!")
  }
}
  
 
  
const Form = () => {

    return (
        <form onSubmit={submitForm} className="form box">
        <div className="indivisual flex ">
          <label className="label__ ">From</label>
          <div className='flex-ver input'>
            <input type="text" placeholder="harshit" id="from" className="grow"></input>
            <label className="label__domain">@ImHarshit.tech</label>
          </div>
        </div>
        <div className='indivisual flex'>
            <label className="label__">To</label>
            <input type="email" placeholder="abc@gmail.com" id="to" className="input"></input>
        </div>
        <div className='indivisual flex'>
            <label className="label__">Name</label>
            <input type="text" placeholder="Name" id="name" className="input"></input>
        </div>
        <div className='indivisual flex'>
            <label className="label__">Subject</label>
            <input type="text" placeholder="Subject" id="sub" className="input"></input>
        </div>
        <div className='indivisual flex'>
            <label className="label__">Body</label>
            <textarea type="text" placeholder="Body" id="body"></textarea>
        </div>
        <div className='indivisual flex'>
            <label className="label__">Html</label>
            <textarea type="text" placeholder="Html ( Optional )" id="html"></textarea>
        </div>
        <div className='indivisual '>
            <button>Send</button>
        </div>
        <ToastContainer
          position="bottom-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
    </form>
    );
 } 
export default Form;
   